import React from 'react';
import { Link } from '../Link.jsx';
import AuthorizedAction from '../AuthorizedAction.js';
import { getOrgSlug } from '../../lib/utils.js';

export const PortfolioInfoLink = ({ portfolioId, ...props }) => (
  <AuthorizedAction action="read" subject="portfolio">
    <Link
      route="portfolio/show/info"
      params={{ portfolioId, slug: getOrgSlug() }}
      {...props}
    />
  </AuthorizedAction>
);

export const PortfolioSettingsLink = ({ portfolioId, ...props }) => (
  <AuthorizedAction action="update" subject="portfolio">
    <Link
      route="portfolio/settings"
      params={{ portfolioId, slug: getOrgSlug() }}
      {...props}
    />
  </AuthorizedAction>
);

export const PortfolioProjectsLink = ({ portfolioId, ...props }) => (
  <AuthorizedAction action="read" subject="portfolio">
    <Link
      route="portfolio/show/projects"
      params={{ portfolioId, slug: getOrgSlug() }}
      {...props}
    />
  </AuthorizedAction>
);

export const AddParentPortfolioLink = ({ ...props }) => (
  <AuthorizedAction action="create" subject="parentPortfolio">
    <Link
      route="parent-portfolio/new"
      params={{ slug: getOrgSlug() }}
      {...props}
    />
  </AuthorizedAction>
);

export const EditParentPortfolioLink = ({ parentPortfolioId, ...props }) => (
  <AuthorizedAction action="update" subject="portfolio">
    <Link
      route="parent-portfolio/edit"
      params={{ parentPortfolioId, slug: getOrgSlug() }}
      {...props}
    />
  </AuthorizedAction>
);

export const AddPortfolioLink = ({ ...props }) => (
  <AuthorizedAction action="create" subject="portfolio">
    <Link
      route="portfolio/new/step-general"
      params={{ slug: getOrgSlug() }}
      {...props}
    />
  </AuthorizedAction>
);

export const EditPortfolioLink = ({ portfolioId, ...props }) => (
  <AuthorizedAction action="update" subject="portfolio">
    <Link
      route="portfolio/edit/step-general"
      params={{ portfolioId, slug: getOrgSlug() }}
      {...props}
    />
  </AuthorizedAction>
);
